import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Modal, Alert, Button, Form } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const EditarCentroCostoModal = ({ handleClose, show, idEdicion, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [buscando, setBuscando] = React.useState(true)

  const infoDetalleAsientoRef = React.useRef(null)

  React.useEffect(() => {
    AsientoContableService.obtenerDetallexIdAsInfoCentroCosto(idEdicion)
      .then(({ data }) => {
        if (data) {
          infoDetalleAsientoRef.current = {
            _idCentroCostoNivel1: data._idCentroCostoNivel1,
            _idCentroCostoNivel2: data._idCentroCostoNivel2
          }
        }
      })
      .catch(() => {
        infoDetalleAsientoRef.current = null
      })
      .finally(() => {
        setBuscando(false)
      })
  }, [idEdicion])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      AsientoContableService.actualizarDetallexIdAsCentroCosto(idEdicion, data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado los datos.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, idEdicion, reloadTable, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Editar centro costo</Modal.Title>
      </Modal.Header>
      {buscando ? (
        <>
          <Modal.Body>
            <Alert color='info'>Obteniendo información.</Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button color='secondary' outline onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          {infoDetalleAsientoRef.current ? (
            <Formik initialValues={infoDetalleAsientoRef.current} onSubmit={onSubmit}>
              {({ handleSubmit, errors, touched, values, isSubmitting }) => (
                <>
                  <Modal.Body>
                    <Form>
                      <FormGroups.CentroCostoNivel1FormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors._idCentroCostoNivel1}
                        iTouched={touched._idCentroCostoNivel1}
                      />
                      <FormGroups.CentroCostoNivel2FormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors._idCentroCostoNivel2}
                        iTouched={touched._idCentroCostoNivel2}
                        idNodoPadre={values._idCentroCostoNivel1}
                      />
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button color='secondary' outline onClick={handleClose}>
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit}>Guardar</Button>
                  </Modal.Footer>
                </>
              )}
            </Formik>
          ) : (
            <>
              <Modal.Body>
                <Alert color='danger'>No se pudo obtener información del detalle.</Alert>
              </Modal.Body>
              <Modal.Footer>
                <Button color='secondary' outline onClick={handleClose}>
                  Cancelar
                </Button>
              </Modal.Footer>
            </>
          )}
        </>
      )}
    </Modal>
  )
}

export default React.memo(EditarCentroCostoModal)
